import type { TrackingCourier } from 'ts-tracking-number'
import { fedex, dhl, ups, usps } from 'ts-tracking-number'

const couriers: readonly TrackingCourier[] = [usps, ups, fedex, dhl]

export default couriers
